// src/components/InfoDisplayBox.jsx
import React, { useState } from 'react';
import { Box, Typography, Modal } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from "@mui/icons-material/Close";
import { useResolutionScale } from '../../hooks';

const BookingInfoPopup = ({ 
  value, 
  scanjobResultInfo,
  isAssemblyLine = false, 
  infoData = {}, 
  sx = {} 
}) => {

  const [open, setOpen] = useState(false);
  const handleInfo = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { scaleValue } = useResolutionScale();

  const hasScanData =
    Array.isArray(scanjobResultInfo?.scanJobResults) &&
    scanjobResultInfo.scanJobResults.length > 0;

  return (
    <>
      {/* Display section */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          ...sx,
        }}
      >
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: isAssemblyLine ? `${scaleValue(40)}px` : `${scaleValue(20)}px`,
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          {value}
        </Typography>

        {hasScanData && (
          <InfoIcon 
            onClick={handleInfo} 
            sx={{ 
              cursor: 'pointer', 
              color: 'primary.main',
              '&:hover': { color: 'primary.dark' },
            }} 
          />
        )}
      </Box>

      {/* Popup modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="info-modal-title"
        closeAfterTransition
        sx={{
          backdropFilter: 'blur(1px)',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: `${scaleValue(360)}px`,
            bgcolor: 'background.paper',
            borderRadius: `${scaleValue(24)}px`,
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
            p: `${scaleValue(32)}px`,
            outline: 'none',
            transition: 'all 0.3s ease',
          }}
        >
          <CloseIcon
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: `${scaleValue(12)}px`,
              right: `${scaleValue(12)}px`,
              cursor: "pointer",
              color: "grey.600",
              "&:hover": { color: "black" }
            }}
          />

          <Typography
            id="info-modal-title"
            variant="h6"
            sx={{
              fontWeight: 700,
              mb: `${scaleValue(16)}px`,
              color: 'primary.main',
              textAlign: 'center',
              borderBottom: '1px solid #e0e0e0',
              pb: `${scaleValue(8)}px`,
            }}
          >
            Scan Details
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: `${scaleValue(8)}px` }}>
            <Typography variant="body2">
              <strong>Scan Serial No:</strong>{' '}
              {scanjobResultInfo?.scanJobResults[0]?.scannedSerialNumber || 'N/A'}
            </Typography>

            <Typography variant="body2">
              <strong>Value:</strong> {infoData.value || 'N/A'}
            </Typography>

            <Typography variant="body2">
              <strong>Scan Part Number:</strong>{' '}
              {scanjobResultInfo?.scanJobResults[0]?.scannedPartNumber || 'N/A'}
            </Typography>

            <Typography variant="body2">
              <strong>Status:</strong>{' '}
              {scanjobResultInfo?.status || 'N/A'}
            </Typography>

            {scanjobResultInfo?.scanJobResults[0]?.skipReason && (
              <Box
                sx={{
                  mt: `${scaleValue(8)}px`,
                  p: `${scaleValue(12)}px`,
                  borderRadius: `${scaleValue(12)}px`,
                  bgcolor: 'rgba(255, 0, 0, 0.05)',
                  border: '1px solid rgba(255, 0, 0, 0.2)',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: 'error.main', fontWeight: 500 }}
                >
                  <strong>Skip Reason:</strong>{' '}
                  {scanjobResultInfo.scanJobResults[0].skipReason}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default BookingInfoPopup;
